var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3358_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3352 3.05282L17.7866 3.7193C20.1665 4.07541 21.3953 5.9766 21.0392 8.35357L20.0799 14.7674C19.7238 17.1444 17.9929 18.6029 15.612 18.2468L11.1616 17.5803C8.78173 17.2242 7.55286 15.3239 7.908 12.946L8.86832 6.53217C9.22346 4.1552 10.9622 2.69866 13.3352 3.05282Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01798 5.875L6.15744 6.81976C3.86901 7.57284 2.96998 9.65305 3.73279 11.9415L5.75755 18.0985C6.5116 20.3781 8.46436 21.5223 10.7431 20.7693L15.03 19.3614C15.7471 19.1347 16.3464 18.7533 16.7823 18.2716",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3358_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.2a888836800d695c1ff2a33926c3d94d.svg";
export { ForwardRef as ReactComponent };